import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "../../core/shared/shared.module";
import { ProjectsRest } from "../projects.rest";
import { ProjectDetailsRouting } from "./project-details.routing";
import { ProjectDetailsComponent } from "./project-details.component";
import { ProjectDetailsHeaderComponent } from "./project-header/project-header.component";
import { CustomersListModule } from "../../company/customers/customers-list/customers-list.module";
import { CustomersListComponent } from "../../company/customers/customers-list/customers-list.component";
import { EmployeesListComponent } from "../../company/employees/employee-list/employees-list.component";
import { EmployeesModule } from "../../company/employees/employes.module";
import { ProjectStepListComponent } from "../projectstep-list/projectstep-list.component";
@NgModule({
    imports:[CommonModule, ProjectDetailsRouting, SharedModule, CustomersListModule, EmployeesModule],
    entryComponents: [CustomersListComponent, EmployeesListComponent],
    declarations:[ProjectDetailsComponent, ProjectDetailsHeaderComponent, ProjectStepListComponent],
    exports: [ProjectDetailsHeaderComponent, ProjectStepListComponent],
    providers: [ProjectsRest]
})
export class ProjectDetailsModule{}